import React from "react";
import styled from "@emotion/styled";

const StyledDiv = styled.div`
  -webkit-mask: var(--image-src-url) no-repeat center;
  mask: var(--image-src-url) no-repeat center;
  height: var(--image-height);
  width: var(--image-width);
  background-color: hsl(var(--color-gray-700));
  background-clip: border-box; /* Fallback for mask rendering */
  transform: translateZ(
    0
  ); /* Force hardware acceleration. Fixed the icon disappear issue on safari */
`;

type SvgSrcIconProps = {
  src: string;
  height?: number;
  width?: number;
  title?: string;
  className?: string;
};

const SvgSrcIcon = ({
  src,
  height,
  width,
  title,
  className,
}: SvgSrcIconProps) => {
  const dynamicStyles = {
    "--image-width": width ? width + "px" : undefined,
    "--image-height": height ? height + "px" : undefined,
    "--image-src-url": `url("${src}")`,
  } as React.CSSProperties;

  return (
    <StyledDiv
      className={`mb-0 ${className ? className : ""}`}
      title={title}
      style={dynamicStyles}
    ></StyledDiv>
  );
};

export { SvgSrcIcon };
